export default "__VITE_ASSET__DV72_NHy__"